<style lang="scss">
.page-home {
  display: flex;
  flex: 1 1 0;
  overflow: hidden;
  > .click-tip {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      color: rgba(92, 96, 102, 1);
    }
  }
}
</style>

<template>
  <div class="page-home">
    <site />
    <router-view v-if="siteId"></router-view>
    <div v-else class="click-tip">
      <img src="@/assets/click-tip.svg" />
      <p>点击左侧站点查看详情</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import site from './site.vue'

export default {
  props: {
    siteId: {
      type: Number
    }
  },
  name: 'home',
  components: {
    site
  }
}
</script>
